import React, {forwardRef, useCallback, useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Button, ButtonToolbar, Divider, Form, Input, SelectPicker, toaster} from 'rsuite';
import {getClearances} from "../../service/dataService";
import {getUserInformation, updateUserInformation} from "../../service/userService";
import {setUserInfo} from "../../redux/userSlice";
import SuccessNotification from "../notifications/SuccessNotification";
import {USER_PROFILE_UPDATE_ERROR, USER_PROFILE_UPDATE_SUCCESS} from "../../service/constants";
import ErrorNotification from "../notifications/ErrorNotification";
import {profileModel} from "../form/models";

const sellStatementTextArea = forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);
const sellStatementPlaceholder = "[OPTIONAL] Executive summary statement about you: Engineer with X years of experience in ... etc...";

const Profile = () => {
    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state.user.userInfo );
    const [clearances, setClearances] = useState([]);
    const [localState, setLocalState] = useState(userInfo);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = useCallback((event) => {
        setLocalState({...localState, ...event});
    }, [localState]);

    useEffect(() => {
        getClearances().then((data) => {
            // format the data into InputPicker format for now
            setClearances(data.map(ele => ({label: ele.clearanceName, value: ele.clearanceName})));
            }
        );
    }, []);

    const submitProfileEdit = useCallback((isFormValid) => {
        if(!isFormValid) return;
        updateUserInformation(localState).then(({result}) => {
            if (result === 'success') {
                getUserInformation(userInfo.email).then((userInfo) => {
                    toaster.push(<SuccessNotification message={USER_PROFILE_UPDATE_SUCCESS} />, { placement: 'topCenter' });
                    dispatch(setUserInfo(userInfo));
                })
            } else {
                toaster.push(<ErrorNotification message={USER_PROFILE_UPDATE_ERROR} />, { placement: 'topCenter' });
            }
        });
    }, [dispatch, localState, userInfo.email]);

    return useMemo(() => {
        return (
            <div className="main-content">
                <h2>Profile</h2>
                <p>
                    You may edit details about yourself here. Email is immutable.
                </p>
                <Divider />
                <Form layout="horizontal"
                      model={profileModel}
                      onChange={handleFormChange}
                      onError={(error) => console.log(error)}
                      onSubmit={submitProfileEdit}
                      formDefaultValue={userInfo}>
                    <Form.Group controlId="email">
                        <Form.ControlLabel>Email</Form.ControlLabel>
                        <Form.ControlLabel>{userInfo.email}</Form.ControlLabel>
                    </Form.Group>
                    <Form.Group controlId="firstName">
                        <Form.ControlLabel>First Name</Form.ControlLabel>
                        <Form.Control name="firstName" />
                    </Form.Group>
                    <Form.Group controlId="lastName">
                        <Form.ControlLabel>Last Name</Form.ControlLabel>
                        <Form.Control name="lastName" />
                    </Form.Group>
                    <Form.Group controlId="sellStatement">
                        <Form.ControlLabel>Sell Statement</Form.ControlLabel>
                        <Form.Control
                            rows={5}
                            name="sellStatement"
                            accepter={sellStatementTextArea}
                            placeholder={sellStatementPlaceholder}
                        />
                    </Form.Group>
                    <Form.Group controlId="clearance">
                        <Form.ControlLabel>Clearance</Form.ControlLabel>
                        <Form.Control name="clearance"
                                      accepter={SelectPicker}
                                      data={clearances}
                        />
                    </Form.Group>
                    <Form.Group>
                        <ButtonToolbar>
                            <Button appearance="primary" type="submit">Save Profile</Button>
                        </ButtonToolbar>
                    </Form.Group>
                </Form>
            </div>
        );
    }, [clearances, handleFormChange, submitProfileEdit, userInfo]);
}

export default Profile;